<template>
    <!-- ========== Left Sidebar start ========== -->
    <b-sidebar id="sidebar-1" shadow width="240px" style="background-color: #003F8A;"  >
        <!-- LOGO -->
        <div class="topbar-left " style="background-color: #003F8A;" >
            <!-- <div class="text-center">
                <a class="logo">
                    <img
                        class="app-logo"
                        width="240px"
                        src="@/assets/images/emi_logo.png"
                    />
                </a>
                <a class="logo-sm">
                    <img
                        class="app-logo"
                        width="240px"
                        src="@/assets/images/emi_logo.png"
                    />
                </a>
                <br />
            </div> -->
            <div class="justify-content-center d-flex">
                <img width="140px" src="@/assets/images/logo_emi.png" class="mt-3 mb-3" />
            </div>

            
        </div>
        <hr style="background-color: #fff;padding: 0px; margin: 0px;">
        <div style="background-color: #003F8A;">
            <!--- Divider -->
            <div class="user-details" >
                <div class="text-center">
                    <img
                        :src="auth.URLFoto"
                        alt=""
                        class="rounded-circle"
                    />
                </div>
                <div class="user-info">
                    <div class="dropdown"></div>

                    <p class="text-white m-0">
                        {{ auth.Persona }}
                    </p>
                    <p class="text-white m-0 small">
                        <b> <i class="fas fa-circle text-success"></i> Sesión Iniciada</b>
                    </p>
                </div>
            </div>
            <Menu />
        </div>
    </b-sidebar>
</template>

<script>
import Menu from "./Menu";

export default {
    name: "Sidebar",
    data() {
        return {
            msg: "Sidebar",
            auth: {},
        };
    },
    components: {
        Menu,
    },
    mounted() {
        this.auth = JSON.parse(localStorage.getItem("persona"));
    },
};
</script>